import { f7, useStore } from 'framework7-react';
import { useEffect } from 'react';
import { usePaymentList } from './api/payment/usePaymentList';
import { useLoadCustomer } from './useLoadCustomer';
import { customerInfoApi } from '@/api/customerApi';
import { AuthInfoState, initialState } from '@/config/initialState';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { paymentStorage } from '@/utils/paymentStorage';
import { storeDispatch } from '@/utils/store';

export const useGmoRedirect = (status?: string) => {
  const router = f7.views.main.router;
  const authInfo = useStore(store, 'authInfo') as AuthInfoState;
  const customerId = paymentStorage.getItem('m_customer_id');
  const token = paymentStorage.getItem('token');
  const { updatePaymentList, isFetched, isFetching } = usePaymentList(false);
  const { isLoggedIn } = useLoadCustomer(
    router,
    token === null ? undefined : token,
    Number(customerId),
    status,
  );
  useEffect(() => {
    if (!isLoggedIn) return;
    const mCustomerId = paymentStorage.getItem('m_customer_id');
    const destinationStep = paymentStorage.getItem('destination_step');
    const destinationPage = paymentStorage.getItem('destination_page');
    const reserveAmount = paymentStorage.getItem('reserve_amount');
    paymentStorage.removeItem('destination_step');
    paymentStorage.removeItem('destination_page');
    const gmoRedirectInfo = {
      destinationStep,
      destinationPage,
      homeNextPage: paths.prepaid,
      openDialog: paths.reservings,
    };
    storeDispatch('setReserveAmount', 'reserveAmount', reserveAmount ?? 0);
    switch (status) {
      // GMOペイメント post →　maikuru バックエンド（api.mobicon.net）からのリダイレクト
      case 'gmo_success':
        if (isLoggedIn && !isFetched && !isFetching) {
          updatePaymentList(Number(mCustomerId));
          if (gmoRedirectInfo.destinationPage) {
            paymentStorage.setItem('paymentRedirectPage', 'car_wash');
            f7.views.main.router.navigate(gmoRedirectInfo.destinationPage, {
              animate: true,
              props: {
                isBackShowPrepaidSummary: true,
              },
            });
          }
          return;
        }
        break;
      case 'gmo_cancel':
        if (isLoggedIn) {
          if (gmoRedirectInfo.destinationPage) {
            paymentStorage.setItem('paymentRedirectPage', 'car_wash');
            f7.views.main.router.navigate(gmoRedirectInfo.destinationPage, {
              animate: true,
              props: {
                isBackShowPrepaidSummary: true,
              },
            });
          }
        }
        break;
      case 'charge_prepaid_success':
        // チャージ処理はWebhook側で完了しているため、
        // フロントエンドでは顧客情報（残高含む）を再取得するだけ
        if (isLoggedIn) {
          paymentStorage.setItem('paymentRedirectPage', 'car_wash');

          // 顧客情報を再取得して残高を更新
          customerInfoApi({ m_customer_id: Number(mCustomerId) }).then(
            async (data) => {
              const {
                customer,
                cars,
                bill_infomations,
                payment_methods,
                prepaids,
                informations,
                campaigns,
              } = data.data;
              Promise.all([
                storeDispatch(
                  'setCarItemInfo',
                  'carItemInfo',
                  cars ? cars[0] : initialState.carItemInfo,
                ),
                storeDispatch('setCustomerInfo', 'customerInfo', customer),
                storeDispatch('setCarsInfo', 'carsInfo', cars),
                storeDispatch('setBillsInfo', 'billsInfo', bill_infomations),
                storeDispatch(
                  'setPaymentMethodsInfo',
                  'paymentMethodsInfo',
                  payment_methods,
                ),
                storeDispatch(
                  'setAdvancePaymentsInfo',
                  'advancePaymentsInfo',
                  prepaids,
                ),
                storeDispatch(
                  'setNotificationsInfo',
                  'notificationsInfo',
                  informations,
                ),
                storeDispatch('setCampaignsInfo', 'campaignsInfo', campaigns),
                storeDispatch(
                  'setWarranties',
                  'warranties',
                  cars?.[0]?.warranties || [],
                ),
                storeDispatch(
                  'setNextWarranties',
                  'nextWarranties',
                  cars?.[0]?.next_warranty || [],
                ),
                storeDispatch(
                  'setCurrentWarranty',
                  'currentWarranty',
                  cars?.[0]?.warranties?.[0],
                ),
                storeDispatch(
                  'setNextWarranty',
                  'nextWarranty',
                  cars?.[0]?.next_warranty?.[0],
                ),
              ]);
            },
          );
        }
        break;
      case 'charge_prepaid_cancel':
        // chargePrepaidPageでadvancePaymentInfoを参照しているため
        // advancePaymentInfoがfalsyな値の場合は遷移しない
        if (store.state.advancePaymentsInfo[0]) {
          router.navigate(paths.chargePrepaid, {
            animate: false,
          });
        }
        break;
      default:
        break;
    }
  }, [isLoggedIn]);
};
